module.exports = __webpack_public_path__ + "img/eyes.eea9f4f3.png";